import React from 'react';
import { Link } from 'react-router-dom';
import gitImage from '../../assets/images/git.webp';

const RelatedPost = ({blog:{image, title, tags, createdAt, id}}) => {
    return (
        <div className="card">
          <Link to={`/posts/${id}`}>
            <img src={image} className="card-image" alt="" />
          </Link>
          <div className="p-4">
            <Link to={`/posts/${id}`} className="text-lg post-title lws-RelatedPostTitle">
              {title}
            </Link>
            <div className="mb-0 tags">
            {tags && tags.map((tag, i) => <span key={i}>#{tag}{i === tags.length - 1 ? "": ","} </span>)}
            </div>
            <p>2010-03-27</p>
          </div>
        </div>
    );
};

export default RelatedPost;